module.exports = __webpack_public_path__ + "images/tft-site-banner-bg-laptop.webp";